import { EvalMessageRenderer } from '../eval/eval-renderer'
import { useVibeEvalStore } from '../eval/eval-store'

/**
 * Eval snapshot panels. The eval subsystem is shared: the eval bridge
 * (../eval/use-eval-event-bridge, wired in use-vibe-agent) sinks
 * evaluation_update events into the vibe eval store as per-run cards, and
 * `EvalMessageRenderer` is the shared renderer for them.
 */
export const VibeEvalPanel = () => {
  const evalMessages = useVibeEvalStore((s) => s.evalMessages)

  if (evalMessages.length === 0) return null

  return (
    <>
      {evalMessages.map((message) => (
        <EvalMessageRenderer key={message.id} message={message} />
      ))}
    </>
  )
}
